import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {booleanMetadata} from '../../../../../../utils/builderMetadata'

export type DesignGeneralSettingsParams = {
  showDivider: SettingsParamType.Boolean
}
export const designGeneralSettingsParams = createSettingsParams<DesignGeneralSettingsParams>({
  showDivider: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
    metadata: booleanMetadata(
      true,
      'Shows or hides the divider between the reservation form and the seating areas or time slots',
    ),
  },
})
